<form #form [action]="reqURL" method="post" target="chatWindow">
  <input type="hidden" name="chatBotSessionId" [value]="chatBotSessionId" />
  <input type="hidden" name="chatBotOASAccountId" [value]="chatBotOASAccountId" />
  <input type="hidden" name="chatBotOASUserName" [value]="chatBotOASUserName" />
</form>
@if (enableChatbot && pageReady() && !isPageLoading()) {
  <div class="chat-container" data-cy="chatbot-container">
    <div style="position: relative">
      <iframe
        id="chatWindow"
        aria-label="GasSouth Chatbot"
        [attr.aria-hidden]="!showWindow()"
        name="chatWindow"
        [class.hidden-frame]="!showWindow()"
        class="chat-window"
        data-cy="chatbot-iframe"
      >
      </iframe>
      @if (showToastMessage() && !showWindow()) {
        <div class="chat-toast-message" role="alert" aria-live="polite" data-cy="chatbot-toast">
          <button
            type="button"
            (click)="closeToastMessage()"
            class="toaster-close"
            aria-label="Dismiss chat notification"
            data-cy="btn-chatbot-toast-close"
          >
            <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
          </button>
          {{ toastMessage() }}
        </div>
      }
    </div>
    <button
      type="button"
      class="chat-button-wrapper"
      (click)="showIframe($event)"
      (keydown.enter)="showIframe($event)"
      (keydown.space)="showIframe($event)"
      [attr.aria-expanded]="showWindow()"
      aria-controls="chatWindow"
      aria-label="Open chat assistant"
      data-cy="btn-chatbot-toggle"
    >
      <img
        class="chat-button"
        [src]="pageLabels?.chatBotImg"
        [alt]="pageLabels?.chatBotImgAlt ?? 'Chat with us'"
        data-cy="chatbot-icon"
      />
    </button>
  </div>
}
